import { Group } from "@iventis/types";
import React from "react";

export interface Session {
    id: string;
    groupId: string;
    sessionStart: Date;
    sessionEnd: Date;
    name: string;
    displayText?: string;
    description: string;
    colour: { fill: string; outline: string };
    subEvents?: Session[];
}

export class SectionedGroup {
    public group: Group;

    public sectionStart: number;

    public sectionEnd: number;

    public subGroups?: SectionedGroup[];

    constructor(group: Group, sectionStart: number, sectionEnd: number, subGroups?: SectionedGroup[]) {
        this.group = group;
        this.sectionStart = sectionStart;
        this.sectionEnd = sectionEnd;
        this.subGroups = subGroups;
    }

    public toString = (): string => this.group.groupId;

    public valueOf = (): number => this.sectionStart;
}

export interface SessionComponentProps {
    session: Session;
    contrastTextColour: string;
}

export type SessionComponent<T extends SessionComponentProps = SessionComponentProps> = React.FC<T>;
